import { FC, useEffect, useRef } from 'react';
import cx from 'classnames';
import PartsOverviewCard from './parts-overview-card';

import Styles from './parts-overview.module.scss';
import { useImpressionReadyEvent } from 'hooks/analytics/use-impression-ready-event';
import { PARTS_DIAGRAM_PAGE } from 'constants/analyticsConstants';
import { LineItem, PartDetailsAndSchematicResponse } from 'types/parts-diagram';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';

export interface PartsOverviewProps {
  partDetailsAndSchematicsData: PartDetailsAndSchematicResponse;
  handlePartView: (lineItem: LineItem) => void;
  onHover?: (referenceNumber: string | null) => void;
  shouldHideBtn?: boolean;
}

const PartsOverview: FC<PartsOverviewProps> = ({
  partDetailsAndSchematicsData,
  handlePartView,
  onHover,
  shouldHideBtn
}) => {
  const { currency = '', lineItems = [] } = partDetailsAndSchematicsData || {};
  const { fireEvent: fireEventImpressionReady } = useImpressionReadyEvent();
  const { analyticsCommonInfo: { dealerData, model } = {} } = usePartDiagram();
  const { dealerName, id: dealerId } = dealerData || {};
  const impressionFired = useRef(null);

  useEffect(() => {
    if (!impressionFired.current) {
      fireEventImpressionReady({
        dealerId,
        currencyCode: currency,
        products: lineItems,
        model,
        storeName: dealerName,
        list: PARTS_DIAGRAM_PAGE
      });

      impressionFired.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineItems]);

  return (
    <div
      className={cx(
        'w-100 d-flex flex-column overflow-x-hidden overflow-y-scroll',
        Styles['parts-overview__container']
      )}
    >
      {lineItems.map((partItem, index) => {
        const { partNumber = '' } = partItem || {};
        return (
          <PartsOverviewCard
            currency={currency}
            partItem={partItem}
            key={partNumber}
            handlePartView={handlePartView}
            onHover={onHover}
            index={index}
            shouldHideBtn={shouldHideBtn}
            lastItem={lineItems.length - 1}
          />
        );
      })}
    </div>
  );
};

export default PartsOverview;
